export default {
      id: "oc-user-delete-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite.svg#oc-user-delete",
      toString: function () {
        return this.url;
      }
    }